import { render, staticRenderFns } from "./specialTopic.vue?vue&type=template&id=4f401e2e&scoped=true&"
import script from "./specialTopic.vue?vue&type=script&lang=js&"
export * from "./specialTopic.vue?vue&type=script&lang=js&"
import style0 from "./specialTopic.vue?vue&type=style&index=0&id=4f401e2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f401e2e",
  null
  
)

export default component.exports